<template>
  <div class="background-container">
  <div v-if="pairs.length > pageSize" class="search-wrapper">
    <div class="search-container align-left">
      <input
        type="text"
        class="form-control search-input"
        v-model="searchText"
        @keyup.enter="searchInObject"
      />
      <i class="fa fa-search search-icon" @click="searchInObject"></i>
    </div>
  </div>
    <table class="table table-borderless">
      <tbody>
        <tr v-for="(pair, index) in displayedPairs" :key="pair.key" class="flex-row">
          <td class="flex-cell">
            {{ pair.key }}
          </td>
          <td class="flex-cell">
            {{ pair.value }}
          </td>
          <td class="flex-cell ml-4">
            <el-popover
              placement="bottom-end"
              trigger="click"
              :width="fit-content"
              :visible="popoverVisible[index]"
            >
              <template #reference>
                <button
                  class="btn add-filter-btn edit-btn"
                  @click="openPopover(index, pair.value)"
                >
                  <i class="ri-pencil-fill medium-icon mr-0"></i>
                </button>
              </template>
              <div class="filter-content">
                <div class="filter-row mb-2">
                  <div class="filter-label-input mr-2">
                    <label>Field</label>
                    <el-input
                      class="filter"
                      :model-value="pair.key"
                      disabled
                    />
                  </div>
                  <div class="filter-label-input mr-2">
                    <label>Type</label>
                    <el-select
                      :model-value="valueType"
                      disabled
                      placeholder="Select"
                    >
                    </el-select>
                  </div>
                  <div
                    v-if="selections"
                    class="filter-label-input"
                  >
                    <label>Value</label>
                    <el-select
                      :model-value="newValue"
                      @update:model-value="value => newValue = value"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="item in schema.selections"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </div>
                  <div
                    v-else-if="(valueType === 'number' || valueType === 'string')"
                    class="filter-label-input"
                  >
                    <label>Value</label>
                    <el-input
                      class="filter"
                      :class="{ 'is-invalid': invalidValueInput }"
                      :model-value="newValue"
                      @update:model-value="value => newValue = value"
                    />
                    <span
                      v-if="invalidValueInput"
                      class="invalid-input-message"
                      >*Invalid input</span
                    >
                  </div>
                  <div
                    v-else-if="valueType === 'boolean'"
                    class="filter-label-input"
                  >
                    <label>Value</label>
                    <el-select
                      :model-value="newValue"
                      @update:model-value="value => newValue = value"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="item in [true, false]"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </div>
                  <div
                    class="filter-label-input ml-2"
                    v-if="name === 'devices'"
                  >
                    <label>Device Type</label>
                    <el-select
                      :model-value="deviceToDeviceType[pair.id]"
                      @update:model-value="value => deviceToDeviceType[pair.id] = value"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="item in allDeviceTypes"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="filter-actions">
                <div class="action-buttons">
                  <button
                    @click="onCancelPopover(index)"
                    class="btn action-btn mr-2"
                  >
                    Cancel
                  </button>
                  <button
                    @click="handleUpdateField(index, pair)"
                    class="btn action-btn apply-btn"
                  >
                    Update
                  </button>
                </div>
              </div>
            </el-popover>
            <button
                  class="btn add-filter-btn edit-btn ml-1"
                  @click="removeItem(pair.key)"
                >
                  <i class="ri-delete-bin-fill medium-icon"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="pairs.length > pageSize" class="pagination-container">
    <el-pagination
      small
      background
      layout="prev, pager, next"
      :total="numTotalItems"
      :current-page="currentPage"
      :page-size="pageSize"
      @current-change="handlePageChange"
    />
  </div>
    </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'
import { updateDocument } from '../../../services/useDocument'
import { deleteField, doc, getDoc, updateDoc } from 'firebase/firestore'
import { ElMessageBox } from 'element-plus'
import getAllDeviceTypes from '../../../composables/getAllDeviceTypes'
import firebase from '../../../../firebase'
import updateDevice from '../../../composables/updateDevice'

export default {
  props: {
    pairs: {
      type: Array,
      required: true
    },
    documentId: {
      type: String
    },
    collection: {
      type: Object
    },
    name: {
      type: String
    },
    document: {
      type: Object
    }
  },
  setup (props, context) {
    const popoverVisible = ref([])
    const newValue = ref(null)
    const valueType = ref(null)
    const invalidValueInput = ref(false)
    const selections = ref(false)
    const { handlelUpdate } = updateDocument(props.collection.id, props.documentId)

    const schema = ref(null)
    const searchText = ref('')
    const filteredPairs = ref([])
    const numTotalItems = ref(0)
    const { allDeviceTypes, loadDeviceTypes } = getAllDeviceTypes()
    const deviceToDeviceType = ref({})

    onMounted(async () => {
      if (props.name === 'devices') {
        loadDeviceTypes()

        for (const pair of props.pairs) {
          const docRef = doc(firebase.db, 'devices', pair.id)
          const docSnap = await getDoc(docRef)

          if (docSnap.exists()) {
            deviceToDeviceType.value[pair.id] = docSnap.data().deviceType
          } else {
            deviceToDeviceType.value[pair.id] = null
          }
        }
      }
    })

    const filterPairs = () => {
      if (!searchText.value) {
        filteredPairs.value = props.pairs
      } else {
        filteredPairs.value = props.pairs.filter(pair => {
          return pair.key.toLowerCase().includes(searchText.value.toLowerCase()) ||
                 pair.value.toString().toLowerCase().includes(searchText.value.toLowerCase())
        })
      }
      numTotalItems.value = filteredPairs.value.length
    }

    // Watch for changes in pairs
    watch(() => props.pairs, async () => {
      filterPairs()

      if (props.name === 'devices') {
        for (const pair of props.pairs) {
          const docRef = doc(firebase.db, 'devices', pair.id)
          const docSnap = await getDoc(docRef)

          if (docSnap.exists()) {
            deviceToDeviceType.value[pair.id] = docSnap.data().deviceType
          } else {
            deviceToDeviceType.value[pair.id] = null
          }
        }
      }
    })

    onMounted(async () => {
      filteredPairs.value = props.pairs
      numTotalItems.value = props.pairs.length

      for (let i = 0; i < props.pairs.length; i++) {
        popoverVisible.value.push(false)
      }
      if (props.collection.schema && props.collection.schema[props.name]) {
        schema.value = props.collection.schema[props.name]
        valueType.value = schema.value.value

        if (valueType.value === 'selections') {
          valueType.value = typeof schema.value.selections[0]
          selections.value = true
        }
      }
    })

    const togglePopovervisibility = (index) => {
      popoverVisible.value[index] = !popoverVisible.value[index]
    }

    const onCancelPopover = (index) => {
      popoverVisible.value[index] = false
      newValue.value = null
      invalidValueInput.value = false
    }

    const removeItem = async (key) => {
      ElMessageBox.confirm(`This will delete the data at '${key}'' from the document`, 'Delete Data', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await handlelUpdate({
          [`${props.name}.${key}`]: deleteField()
        })
      }).catch((e) => {
        console.log(e)
      })
    }

    const openPopover = (index, value) => {
      togglePopovervisibility(index)
      newValue.value = value
    }

    const handleUpdateField = async (index, pair) => {
      let updateValue
      invalidValueInput.value = false
      switch (valueType.value) {
        case 'number':
          updateValue = parseFloat(newValue.value)
          if (isNaN(newValue)) {
            invalidValueInput.value = true
            return
          }
          break
        case 'boolean':
        case 'string':
          updateValue = newValue.value
          break
        default:
          return
      }

      try {
        await handlelUpdate({
          [`${props.name}.${pair.key}`]: updateValue
        })

        if (props.name === 'devices') {
          const { updateDeviceBasedOnId } = updateDevice()
          await updateDeviceBasedOnId(pair.id, deviceToDeviceType.value[pair.id], props.documentId)
        }
        togglePopovervisibility(index)
      } catch (error) {
        console.error(error)
      }
    }

    const currentPage = ref(1)
    const pageSize = 10

    const displayedPairs = computed(() => {
      const start = (currentPage.value - 1) * pageSize
      return filteredPairs.value.slice(start, start + pageSize)
    })

    const handlePageChange = (newPage) => {
      currentPage.value = newPage
    }

    const searchInObject = () => {
      currentPage.value = 1
      if (!searchText.value) filteredPairs.value = props.pairs
      filteredPairs.value = props.pairs.filter(pair => {
        return pair.key.toLowerCase().includes(searchText.value.toLowerCase()) ||
               pair.value.toString().toLowerCase().includes(searchText.value.toLowerCase())
      })
      numTotalItems.value = filteredPairs.value.length
    }

    return {
      popoverVisible,
      togglePopovervisibility,
      valueType,
      newValue,
      invalidValueInput,
      onCancelPopover,
      removeItem,
      selections,
      openPopover,
      handleUpdateField,
      schema,
      currentPage,
      pageSize,
      displayedPairs,
      handlePageChange,
      searchText,
      searchInObject,
      numTotalItems,
      allDeviceTypes,
      deviceToDeviceType
    }
  }
}
</script>

<style scoped>

.table td {
  padding: 10px;
  padding-left: 10px;
}

.edit-btn {
  visibility: hidden;
  transition: none;
  display: flex;
  align-items: center;
  margin-right: 5px;
  padding: 0;
  border: none;
  background: transparent;
}

.flex-row {
  display: flex;
  align-items: center;
}

.flex-cell {
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  align-items: center;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 13px !important;
}

.medium-icon {
  font-size: 16px;
  color: #a09e9e;
}

.filter-row span {
  white-space: nowrap;
  margin-right: 8px;
}

.filter {
  flex: 1;
  margin-right: 8px;
}

.filter-select {
  min-width: 190px;
}

.filter-content {
  margin: 10px 10px 20px 10px;
  display: flex;
  flex-direction: column;
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--border-color);
  padding-top: 15px;
  margin-left: -15px;
  margin-right: -15px;
  padding-left: 15px;
  padding-right: 15px;
}

.filter-label-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
  position: relative;
}

.filter-label-input label {
  margin-bottom: 10px;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}

.action-buttons {
  display: flex;
}

.filter-label-input label {
  margin-bottom: 0.5rem;
}

.filter {
  width: 100%;
}

.search-wrapper {
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 20px;
  margin-left: 40px;
}

.search-container {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0px !important;
  margin: 10px;
}

.search-input {
  padding-right: 30px;
}

.form-control.search-input {
  height: 32px;
  line-height: 32px;
  border-radius: 5px;
}

.search-icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
}

.invalid-input-message {
  color: #ff4d4f;
  font-size: 11px;
  position: absolute;
  bottom: -20px;
  left: 0;
  visibility: hidden;
}

.filter-label-input .is-invalid + .invalid-input-message {
  visibility: visible;
}

.action-btn {
  background-color: #e1e5e8;
  color: black;
  font-size: 13px !important;
}

.apply-btn {
  background-color: green;
  color: white;
}

.apply-btn:hover {
  color: white;
  background-color: darkgreen;
}

.table {
  margin-bottom: 0;
  width: 95%;
  margin-left: 50px;
  color: #606266;
  font-size: 14px;
}

.flex-row {
  display: flex;
  align-items: center;
}

.flex-cell {
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.table tbody tr:hover .edit-btn,
.table tbody tr:hover .delete-btn {
  visibility: visible;
}

.table tbody tr:hover {
  background-color: var(--light-grey) !important;
  border-radius: 4px;
}

.pagination-container {
  display: flex;
  justify-content: center;
}

</style>
